import s from "../../@babel/runtime/helpers/esm/regeneratorRuntime.mjs";
import D from "../../@babel/runtime/helpers/esm/toConsumableArray.mjs";
import d from "../../@babel/runtime/helpers/esm/asyncToGenerator.mjs";
var G = /* @__PURE__ */ function() {
  var R = d(/* @__PURE__ */ s().mark(function k(v, y) {
    var o, f, m, h, F, b, g, w;
    return s().wrap(function(l) {
      for (; ; )
        switch (l.prev = l.next) {
          case 0:
            b = function() {
              return b = d(/* @__PURE__ */ s().mark(function u(r) {
                return s().wrap(function(a) {
                  for (; ; )
                    switch (a.prev = a.next) {
                      case 0:
                        return a.abrupt("return", new Promise(function(t) {
                          r.file(function(n) {
                            y(n) ? (r.fullPath && !n.webkitRelativePath && (Object.defineProperties(n, {
                              webkitRelativePath: {
                                writable: !0
                              }
                            }), n.webkitRelativePath = r.fullPath.replace(/^\//, ""), Object.defineProperties(n, {
                              webkitRelativePath: {
                                writable: !1
                              }
                            })), t(n)) : t(null);
                          });
                        }));
                      case 1:
                      case "end":
                        return a.stop();
                    }
                }, u);
              })), b.apply(this, arguments);
            }, F = function(u) {
              return b.apply(this, arguments);
            }, h = function() {
              return h = d(/* @__PURE__ */ s().mark(function u(r) {
                var c, a, t, n, e;
                return s().wrap(function(i) {
                  for (; ; )
                    switch (i.prev = i.next) {
                      case 0:
                        c = r.createReader(), a = [];
                      case 2:
                        return i.next = 5, new Promise(function(P) {
                          c.readEntries(P, function() {
                            return P([]);
                          });
                        });
                      case 5:
                        if (t = i.sent, n = t.length, n) {
                          i.next = 9;
                          break;
                        }
                        return i.abrupt("break", 12);
                      case 9:
                        for (e = 0; e < n; e++)
                          a.push(t[e]);
                        i.next = 2;
                        break;
                      case 12:
                        return i.abrupt("return", a);
                      case 13:
                      case "end":
                        return i.stop();
                    }
                }, u);
              })), h.apply(this, arguments);
            }, m = function(u) {
              return h.apply(this, arguments);
            }, o = [], f = [], v.forEach(function(p) {
              return f.push(p.webkitGetAsEntry());
            }), g = /* @__PURE__ */ function() {
              var p = d(/* @__PURE__ */ s().mark(function u(r, c) {
                var a, t;
                return s().wrap(function(e) {
                  for (; ; )
                    switch (e.prev = e.next) {
                      case 0:
                        if (r) {
                          e.next = 2;
                          break;
                        }
                        return e.abrupt("return");
                      case 2:
                        if (r.path = c || "", !r.isFile) {
                          e.next = 10;
                          break;
                        }
                        return e.next = 6, F(r);
                      case 6:
                        a = e.sent, a && o.push(a), e.next = 15;
                        break;
                      case 10:
                        if (!r.isDirectory) {
                          e.next = 15;
                          break;
                        }
                        return e.next = 13, m(r);
                      case 13:
                        t = e.sent, f.push.apply(f, D(t));
                      case 15:
                      case "end":
                        return e.stop();
                    }
                }, u);
              }));
              return function(r, c) {
                return p.apply(this, arguments);
              };
            }(), w = 0;
          case 9:
            if (!(w < f.length)) {
              l.next = 15;
              break;
            }
            return l.next = 12, g(f[w]);
          case 12:
            w++, l.next = 9;
            break;
          case 15:
            return l.abrupt("return", o);
          case 16:
          case "end":
            return l.stop();
        }
    }, k);
  }));
  return function(v, y) {
    return R.apply(this, arguments);
  };
}();
export {
  G as default
};
//# sourceMappingURL=traverseFileTree.mjs.map
